module.exports = __webpack_public_path__ + "img/Transform20.d319b42f.png";